class MiniCartButton extends HTMLElement {
  onClick = () => {
    document.dispatchEvent(new CustomEvent("mini-cart:open"));
  };

  connectedCallback() {
    this.addEventListener("click", this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
  }
}

if (!customElements.get("mini-cart-button")) {
  customElements.define("mini-cart-button", MiniCartButton);
}
